import { ScriptSource, UploadFileType } from "./formTemplateDataType";
import logo from "../../public/assets/images/ontario_logo.svg"
import email from "../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-email.svg";
import account from "../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-account.svg";
import document from "../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-document.svg";
import exit from '../../public/assets/css/ontario-design-system/icons/svg/ontario-icon-exit.svg';
import { fr } from "date-fns/locale";
import { lab } from "d3";

export const elementTypeList = [
    { val: 'Text', label: 'Text' },
    { val: 'Accordions', label: 'Accordions'},
    { val: 'Address', label: 'Address' },
    { val: 'BusinessNumber', label: 'Business Number' },
    { val: 'Button', label: 'Button' },
    { val: 'Callout', label: 'Callout' },
    { val: 'Checkbox', label: 'Check box' },
    { val: 'CheckboxWithTextbox', label: 'Checkbox with input' },
    { val: 'CheckboxWithInlineTextbox', label: 'Checkbox with inline input' },
    { val: 'EmailConfirmation', label: 'Confirmation Email' }, 
    { val: 'Contact', label: 'Contact details' },
    { val: 'Currency', label: 'Currency' },
    { val: 'CustomErrorAlerts', label: 'Custom Error Alerts'},
    { val: 'CMAQuestion', label: 'CMA Question'},
    { val: 'DataTable', label: 'DataTable' },
    { val: 'Date', label: 'Date' },
    { val: 'DateTime', label: 'DateTime' },
    { val: 'DriverLicense', label: "Driver's License"},
    { val: 'Dropdown', label: 'Dropdown list' },
    { val: 'Email', label: 'Email' },
    { val: 'EmailButton', label: 'Email with button' },
    { val: 'ErrorAlert', label: 'Error Alert' },
    { val: 'Excel', label: 'Excel' },
    { val: 'Excel Template', label: 'Excel Template' },
    { val: 'Feedback', label: 'Feedback' },
    { val: 'File', label: 'File' },  
    { val: 'Download', label: 'File Download' },
    { val: 'GoogleLookUpAddress', label: 'Google Place Address' },
    { val: 'GroupDropdown', label: 'Group dropdown list' },
    { val: 'HealthCard', label: 'Health Card Number'},
    { val: 'HiddenField', label: 'Hidden Field'},
    { val: 'HTML', label: 'HTML'},
    { val: 'Image', label: 'Image' },
    { val: 'InformationAlert', label: 'Information Alert' },
    { val: 'Invoice', label: 'Invoice' },
    { val: 'LicensePlate', label: 'License Plate Number' },  
    { val: 'CheckGroup', label: 'Multiple choice' },
    { val: 'MultiplePanel', label: 'Multiple panel' },
    { val: 'Number', label: 'Number' },
    { val: 'ODSDate', label: 'ODS Date' },
    { val: 'PCLookUpAddress', label: 'PC Lookup' },
    { val: 'PhoneNumber', label: 'Phone Number' },
    { val: 'PostalCode', label: 'Postal Code' },
    { val: 'PublicSecureButton', label: 'Public Secure Button' },
    { val: 'Questionnaire', label: 'Questionnaire' },
    { val: 'QRCode', label: 'QR Code' },
    { val: 'RadioButton', label: 'Radio Button' },
    { val: 'RecaptchaButton', label: 'Recaptcha Button' },
    { val: 'RepeatButton', label: 'Repeat Button' },
    { val: 'Label', label: 'Rich text' },
    { val: 'Row', label: 'Row' },    
    { val: 'SelectWithRichText', label: 'Selection with rich text'},
    { val: 'StarRating', label: 'Star Rating' },
    { val: 'SuccessAlert', label: 'Success Alert' },
    { val: 'SummaryList', label: 'Summary List' },
    { val: 'Table', label: 'Table' },
    { val: 'TableMenu', label: 'Table Menu'},
    { val: 'TechError', label: 'Techinical Error' },    
    { val: 'TransId', label: 'Transaction ID' },
    { val: 'MultiText', label: 'Text Area' }, 
    { val: 'WarningAlert', label: 'Warning Alert' },
]

export const elementTypeListInTable = [
    { val: 'Text', label: 'Text' },
    { val: 'Button', label: 'Button' },
    { val: 'Checkbox', label: 'Check box' },
    { val: 'CMAButton', label: 'CMA Button' },
    { val: 'CMAKey', label: 'CMA Key' },
    { val: 'Currency', label: 'Currency' },
    { val: 'Date', label: 'Date' },
    { val: 'Email', label: 'Email' },
    { val: 'Dropdown', label: 'Dropdown list' },
    { val: 'CheckGroup', label: 'Multiple choice' },
    { val: 'Key', label: 'Key' },
    { val: 'Number', label: 'Number' },
    { val: 'PhoneNumber', label: 'Phone number' },
    { val: 'RadioButton', label: 'Radio button' },
    { val: 'Label', label: 'Rich text' },
    { val: 'Table', label: 'Table' },
    { val: 'MultiText', label: 'Text Area' },
]

export const summaryListColumnType = [
    { val: 'normal', label: 'Normal' },
    { val: 'key', label: 'Key' },
    { val: 'button', label: 'Button' },
    { val: 'ststus', label: 'Status' }
]

export const calloutOptions = [
    { val: 'timeEstimate', label: 'Time Estimate' },
    { val: 'informational', label: 'Informational' },
    { val: 'alert', label: 'Alert' },
    { val: 'warning', label: 'Warning' },
    { val: 'error', label: 'Error' },
]

export const odsCallOutBoxs = [
    { val: 'HTML', label: 'HTML' },
    { val: 'general', label: 'General' },
    { val: 'timeEstimate', label: 'Time estimate' },
    { val: 'informational', label: 'Informational' },
    { val: 'richText', label: 'RichText' },
    { val: 'warning', label: 'Warning' },
    { val: 'success', label: 'Success' },
    { val: 'error', label: 'Error' },
]

export const addressTypeOption = [
    { val: 'Residential', label: 'Residential' },
    { val: 'Mailing', label: 'Mailing' },
]

export const textTypeOption = [
    { val: 'Value', label: 'Value' },
    { val: 'Input', label: 'Input' },
    { val: 'TextArea', label: 'TextArea'},
];

export const textBoxLengths = [
    { val: 'ontario-input--50-char-width', label: '50 character width' },
    { val: 'ontario-input--40-char-width', label: '40 character width' },
    { val: 'ontario-input--30-char-width', label: '30 character width' },
    { val: 'ontario-input--20-char-width', label: '20 character width' },
    { val: 'ontario-input--12-char-width', label: '12 character width' },
    { val: 'ontario-input--10-char-width', label: '10 character width' },
    { val: 'ontario-input--9-char-width', label: '9 character width' },
    { val: 'ontario-input--8-char-width', label: '8 character width' },
    { val: 'ontario-input--7-char-width', label: '7 character width' },
    { val: 'ontario-input--6-char-width', label: '6 character width' },
    { val: 'ontario-input--5-char-width', label: '5 character width' },
    { val: 'ontario-input--4-char-width', label: '4 character width' },
    { val: 'ontario-input--3-char-width', label: '3 character width' },
    { val: 'ontario-input--2-char-width', label: '2 character width' },
]

export const dateComparisonList = [
    { val: '>', label: 'Later Than' },
    { val: '=', label: 'Equal' },
    { val: '<', label: 'Earlier Than' },
]

export const buttonClassList = [
    { val: 'ontario-button--primary', label: 'ontario-button--primary' },
    { val: 'ontario-button--secondary', label: 'ontario-button--secondary' },
    { val: 'button--22em', label: 'button--22em' },
]



export const readonlyTypeList = [
    { val: 'constant', label: 'Constant' },
    { val: 'calculate', label: 'Calculate' },
]

export const calculationMethodList = [
    { val: 'minus', label: '-' },
    { val: 'plus', label: '+' },
]

export const measurementUnitList = [
    { val: 'Day', label: 'Day' },
    { val: 'Month', label: 'Month' },
    { val: 'Dollar', label: 'Dollar' },
]

export const authticationMethodList = [
    { val: 'em', label: 'Embedded (No Authentication)' },
    { val: 'ps', label: 'Public Secure' },
    { val: 'ad', label: 'Active Directory' },
]
export const SubmissionMethodList = [
    { val: 'get', label: 'GET' },
    { val: 'post', label: 'POST' },
    { val: 'put', label: 'PUT' },
]

export const SummaryStyleList = [
    { val: 'Button', label: 'Button' },
    { val: 'Link', label: 'Link' },
    { val: 'Table', label: 'Table' },
    { val: 'All', label: 'All' },
];

export const fileTypeList: UploadFileType[] = [
    { 
        val: [
            { mimeType: 'application/msword', ext: 'doc' }, 
            { mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', ext: 'docx' },
        ], 
        label: 'Word',
    },
    { 
        val: [
            { mimeType: 'application/vnd.ms-excel', ext: 'xls' }, 
            { mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', ext: 'xlsx' },
        ], 
        label: 'Excel',
    },
    { 
        val: [
            { mimeType: 'application/pdf', ext: 'pdf' }, 
        ], 
        label: 'PDF',
    },
    { 
        val: [
            { mimeType: 'image/png', ext: 'png' }, 
        ], 
        label: 'PNG',
    },
    { 
        val: [
            { mimeType: 'image/jpg', ext: 'jpg' }, 
            { mimeType: 'image/jpeg', ext: 'jpeg' }, 
        ], 
        label: 'JPEG',
    },
];

export const EnvBaseUrl = {
    local: 'http://localhost:4200/on-form/#',
    dev: 'https://dev.cxp.mgcs.gov.on.ca/on-form/#',
    ist: 'https://test.cxp.mgcs.gov.on.ca/on-form/#',
    stg: 'https://stage.cxp.mgcs.gov.on.ca/on-form/#',
    uat: 'https://train.cxp.mgcs.gov.on.ca/on-form/#',
    prod: 'https://cxp.mgcs.gov.on.ca/on-form/#',
};

export type FileSizeUnit = 'MB' | 'GB';
export const UploadFileSizeLimit = {
    size: 20,
    unite: 'MB' as FileSizeUnit,
}

export const FeedbackStatus = {
    Success: '100',
    Failed: '400',
};

export const feedbackStatusOptions = [
    { val: FeedbackStatus.Success, label: 'Success' },
    { val: FeedbackStatus.Failed, label: 'Failed' },
];

export const USER_PROFILE = 'userProfile';

export const AUTH_TOKENS = 'authTokens';

export type MenuOptions = {
    id: string;
    'title-en': string;
    'title-fr': string;
    'link-en'?: string;
    'link-fr'?: string;
    'redirect-uri-en'?: string;
    'redirect-uri-fr'?: string;
    icon: string;
};

export const menuOptions: MenuOptions[] = [
    {
        id: 'myInbox',
        'title-en': 'My Inbox',
        'title-fr': 'Ma boîte de réception',
        'link-en': process.env.CXP_INBOX,
        'link-fr': process.env.CXP_INBOX_F,
        'redirect-uri-en': '/notifications/inbox', 
        'redirect-uri-fr': '/fr/notifications/inbox',
      icon: email,
    },
    {
        id: 'myAccount',
        'title-en': 'My Account',
        'title-fr': 'Mon compte',
        'link-en': process.env.CXP_MYACCOUNT,
        'link-fr': process.env.CXP_MYACCOUNT_F,
        'redirect-uri-en': '/profile/details', 
        'redirect-uri-fr': '/fr/profile/details',
      icon: account,
    },
    {
      id: 'myTransactions',
        'title-en': 'My Orders',
        'title-fr': 'Mes commandes',
        'link-en': process.env.CXP_MYTRANSACTION,
        'link-fr': process.env.CXP_MYTRANSACTION_F,
        'redirect-uri-en': '/transactions', 
        'redirect-uri-fr': '/fr/transactions',
      icon: document,
    },
    {
        id: 'signout',
        'title-en': 'Sign out',
        'title-fr': 'Déconnexion',
        'link-en': process.env.CXP_SIGNOUT,
        'link-fr': process.env.CXP_SIGNOUT_F,
        'redirect-uri-en': '/logout', 
        'redirect-uri-fr': '/fr/logout',
      icon: exit,
    },
  ];

export const headerMenu: {[key: string]: MenuOptions[]} = {
    chc: [ menuOptions[0], menuOptions[1], menuOptions[2], menuOptions[3] ],
    otris: [ menuOptions[1], menuOptions[3]],
    otrip: [ menuOptions[1], menuOptions[3]],
} 

export const CXP_MAX_INBOX_MESSAGES = 3;

export const QustionnaireAnswers = [
    { val: 'None', label: {en: 'None Existence', fr: 'Aucune existence'} },
    { val: 'Initial', label: {en: 'Initial', fr: 'Initial'} },
    { val: 'Defined', label: {en: 'Defined', fr: 'Défini'} },
    { val: 'AdHoc', label: {en: 'Ad-hoc', fr: 'Ad-hoc'} },
    { val: 'Implemented', label: {en: 'Implemented', fr: 'Mis en œuvre'} },
    { val: 'Optimized', label: {en: 'Optimized', fr: 'Optimisé'} },
];

export type TextType = 'Value' | 'Input' | 'TextArea';

export const Scripts: {[key: string]: ScriptSource[]} = {
    QueueIt: [
        {
            source: 'https://static.queue-it.net/script/queueclient.min.js',
            location: 'Head',
        },
        {
            source: 'https://static.queue-it.net/script/queueconfigloader.min.js',
            location: 'Head',
            attributes: [{name: 'data-queueit-c', value: 'ontario'}],
        },
    ],
};

export const CheckStatus = {
    "Payment in Queue" : {
        en: {
            title: "<strong>Payment in Queue</strong>",
            description: "The cheque is scheduled to be processed",
        },
        fr: {
            title: "<strong>Paiement en attente</strong>",
            description: "Le traitement du chèque est prévu.",
        },
    },
    Pending: {
        en: {
            title: "<strong>Pending</strong>",
            description: "Please call 1-833-351-0409.",
        },
        fr: {
            title: "<strong>En attente</strong>",
            description: "Veuillez composer le 1 833 351-0409.",
        },
    },
    Issued: {
        en: {
            title: "<span style='color: #118847'><strong>Issued</strong></span>",
            description: "The cheque has been mailed",
        },
        fr: {
            title: "<span style='color: #118847'><strong>Émis</strong></span>",
            description: "Le chèque a été envoyé par la poste.",
        },
    },
    Cashed: {
        en: {
            title: "<span style='color: #118847'><strong>Cashed</strong></span>",
            description: "The cheque has been deposited",
        },
        fr: {
            title: "<span style='color: #118847'><strong>Encaissé</strong></span>",
            description: "Le chèque a été déposé.",
        },
    },
    Reissued: {
        en: {
            title: "<span style='color: #118847'><strong>Reissued</strong></span>",
            description: "The cheque has been reissued and mailed",
        },
        fr: {
            title: "<span style='color: #118847'><strong>Réémis</strong></span>",
            description: "Le chèque a été réémis et envoyé par la poste.",
        },
    },
    Voided: {
        en: {
            title: "<span style='color: red'><strong>Attention Needed</strong></span>",
            description: "<p>There was a problem with issuing or delivering your cheque.</p><ul><li><strong>If you have already contacted us</strong>, please wait 30 days for us to process your request and provide an update.</li><li><strong>If you have not yet contacted us</strong>, please call us to resolve this problem at 1-833-351-0409</li></ul>",
        },
        fr: {
            title: "<span style='color: red'><strong>Attention requise</strong></span>",
            description: "<p>Un problème est survenu lors de l’émission ou de la livraison de votre chèque.</p><ul><li><strong>Si vous avez déjà communiqué avec nous</strong>, veuillez attendre 30 jours pour que nous puissions traiter votre demande et vous fournir une mise à jour.</li><li><strong>Si vous n’avez pas encore communiqué avec nous</strong>, veuillez nous appeler pour résoudre ce problème au 1 833 351-0409.</li></ul>",
        },
    },
};

export const GradientStatus = {
    status: [
        { val: 0, color: '#CD0000', label: 'Non Existent' },
        { val: 1, color: '#E65D0C', label: 'Initial' },
        { val: 2, color: '#FAA716', label: 'Managed' },
        { val: 3, color: '#A0A02A', label: 'Defined' },
        { val: 4, color: '#71e600', label: 'Quantitively Managed' },
        { val: 5, color: '#338E40', label: 'Optimized' },
    ],

    getColors: () => {
        return GradientStatus.status.map((item) => item.color);
    },

    getLabels: () => {
        return GradientStatus.status.map((item) => item.label);
    },

    getValues: () => {
        return GradientStatus.status.map((item) => item.val);
    },

    getColor: (val: number) => {
        return GradientStatus.status.find((item) => item.val === Math.floor(val))?.color;
    },

    getStringVals: () => {
        return GradientStatus.status.map((item) => item.val.toString());
    },

    getStringVal: (val: number) => {
        return GradientStatus.status.find((item) => item.val === Math.floor(val))?.val.toString();
    }
};


export const ManitenaceReason = {
    Maintenance: 'maintenance',
    Warning: 'warning',
    Error: 'error',
    Info: 'info',
}

export const MaintainableApps = ['chc', 'chc-status', 'chc_123'];

export const TemplateStatus = {
    IN_PROGRESS: 'InProgress', 
    ASSIGNED: 'Assigned',
    APPROVAL_PENDING: 'ApprovalPending',
    REVISION: 'Revision', 
    SUBMITTED: 'Submitted', 
    COMPLETED: 'Completed',
};

export const CMARole = {
    APPROVER: 'A',
    CHAMPION: 'C',
    CS_ADMIN: 'CSA',
}

export const BackHome = {
    Ontario: {
        en: { 
            label: "Back to Ontario.ca", 
            url: "https://www.ontario.ca/page/serviceontario",
        },
        fr: {
            label: "Revenir à Ontario.ca",
            url: "https://www.ontario.ca/page/serviceontario",
        },
    },
    Home: {
        en: {
            label: "Back to home",
            url: `${process.env.PUBLIC_CXP_WEB_BASE_PATH}/auth/signin?redirectUri=/dashboard`,
        },
        fr: {
            label: "Retour à l'accueil",
            url: `${process.env.PUBLIC_CXP_WEB_BASE_PATH}/auth/signin?redirectUri=/fr/dashboard`,
        },
    },
    Back: {
        en: { label: "Back" },
        fr: { label: "Retour" },
    }
}

export enum TOKEN_TYPE {
    API = 'api',
    GRAPH = 'graph',
}
